var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.support_index)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","tile":"","small":"","target":"_blank","to":_vm.to}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-open-in-new")])],1)]}}],null,false,155373157)},[_c('span',[_vm._v(_vm._s(_vm.idxDesc))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }